import { CodeBlock } from '#components/atoms/code/index.ts';
import { Link } from '#components/atoms/link/Link.tsx';
import { replaceResourceIdsWithPlaceholders } from './resource-links.ts';

type Props = {
  data: unknown;
  allowScroll?: boolean;
};

/**
 * Renders JSON data with clickable links for resource IDs
 */
export function LinkifiedJSON({ data, allowScroll = true }: Props) {
  if (data === null || data === undefined) {
    return <CodeBlock allowScroll={allowScroll}>null</CodeBlock>;
  }

  const jsonString = JSON.stringify(data, null, 2);
  const { processedText, resourceLinks } = replaceResourceIdsWithPlaceholders(jsonString);

  // Split the text by placeholder markers and render with links
  const parts = processedText.split(/(__RESOURCE_LINK_\d+__)/);

  return (
    <CodeBlock allowScroll={allowScroll}>
      {parts.map((part, index) => {
        const linkMatch = /^__RESOURCE_LINK_(\d+)__$/.exec(part);
        if (linkMatch?.[1]) {
          const linkIndex = Number.parseInt(linkMatch[1], 10);
          const resourceLink = resourceLinks[linkIndex];
          if (resourceLink?.url) {
            return (
              // eslint-disable-next-line react/no-array-index-key -- This is static text content
              <Link key={index} to={resourceLink.url} className="a">
                {resourceLink.id}
              </Link>
            );
          }
        }
        return part;
      })}
    </CodeBlock>
  );
}
